export default __webpack_public_path__ + "assets/models/e953707f1a6e2e597d26135b6eb6d35b.glb";